exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".showLinksBox{margin:10px 0;border:1px solid #28bbbb;border-radius:3px;padding:10px;display:flex;flex-direction:row}.showLinksText{flex-basis:auto;flex-grow:5}.showLinksText textarea{overflow:hidden}.showLinksAction{flex-basis:auto}.linksLabel{font-size:14px;font-weight:500;line-height:14px;padding-bottom:5px;color:rgba(51,51,51,.87)}.linksFormat{font-size:12px;font-style:italic;line-height:14px;color:rgba(0,0,0,.38);display:block;border:none;outline:none;resize:none;box-shadow:none;padding:0;overflow:auto;width:100%}.show-links-dialog .mw-mini-modal__cancel-button{display:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./apps-ts/outputs/src/app/newsfeeds/newsfeed-show-links-dialog/newsfeed-show-links-dialog.css
 ** module id = 65
 ** module chunks = 0 1
 **/